import React, { useState, useEffect } from "react";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import "../components/Table/Table.css";
import { student_profile } from "../api/Users";

const StudentProfile = ({ userData }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
          student_profile({ student_id: userData.data.student_id })
           .then((res) => {
            setIsLoading(true);
                if (res.status === "success") {
                  setFilteredData(res.data.student_data);
                }
                setIsLoading(false);
            })
        };
        fetchData();
    }, [userData]); 

    return (
        <>
          <TopLoader loading={isLoading ? "50" : "100"} />
          <div className="row col-12 d-flex justify-content-center mt-5 bg-white">
            {/* <div className="construction"></div> */}
          </div>
          <div className="px-0 px-md-3">
            <div className="my-4 col-12 d-flex justify-content-between align-items-center">
              <h5 className="">{t("My Profile")}</h5>
            </div>

              <div className="container">
                <div className="row mt-4">
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Student Name')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].student_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Class')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].class : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Gender')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Gender : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Date Of Birth')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].date_of_birth : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Caste')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Caste_Category : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Sub Caste')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Sub_Caste : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Student Residential Status')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Boarder_Dayscholar : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Hostel Type')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].hostel_attached_to_school : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Date Of Joining')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].joining_date_Boarderel : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Student Hostel Ownership')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Gender : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('School Name')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].school_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Aadhaar No.')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].std_aadhar_no : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Father Name')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].father_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Mother Name')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].mother_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Parents/Guardian Mobile No.')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].Parents_MobileNo : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Domicile District')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].district_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Domicile Block')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].district_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Domicile GP')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].gp_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Domicile Village')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].village_name : ''} disabled />
                    </div>
                    <div className="col-md-4 pb-3">
                        <label className="form-label">{t('Reporting Teacher')}</label>
                        <input type="text" className="form-control" value={filteredData.length > 0 ? filteredData[0].father_name : ''} disabled />
                    </div>
                </div>
              </div> 
          </div>
        </>
      );
};

export default StudentProfile;